import React from "react";

type SecondLevelDrawerCloseContextValue = { closeParentDrawer: (() => void) | undefined };

const SecondLevelDrawerCloseContext = React.createContext<SecondLevelDrawerCloseContextValue>({ closeParentDrawer: undefined });

export { SecondLevelDrawerCloseContext };

export const useSecondLevelDrawerClose = (): SecondLevelDrawerCloseContextValue =>
  React.useContext(SecondLevelDrawerCloseContext);
